<template>
  <router-view/>
  <div class="powered-by">
    <a href="https://teknisa.com" target="_blank">
      <img :src="getPowered()" alt="TEKNISA">
    </a>
  </div>
</template>
<script>
import { idealTextColor } from '@/controllers/libs/Util.js'

export default {
    methods: {
        getPowered: function () {
            return idealTextColor() === '#000000' ?
                require('@/assets/powered-by-teknisa-preta.png') :
                require('@/assets/powered-by-teknisa-branca.png')
        }
    },
    mounted () {
        document.title = 'Cadastro'
    }
}
</script>

<style lang="less">
@import url('https://fonts.googleapis.com/css2?family=AR+One+Sans:wght@400;700&display=swap');
@font-face {
  font-family: 'Folkafe Regular';
  src: url('~@/assets/fonts/folkafe-regular/Folkafe Regular.otf') format('opentype');
}
@font-face {
  font-family: 'Aller Regular';
  src: url('~@/assets/fonts/aller/Aller_Std_Rg.ttf') format('truetype');
}
// * {
//   outline: 1px solid #f00 !important;
// }
:root {
  --primaryColor: #001674;
  --secundaryColor: #3c93fc;
  --footerColor: #3c93fc;
  --buttonColor: #001674;
}
body, h1, h2{
  margin: 0;
  padding: 0;
}
h2 {
  font-family: 'Folkafe Regular', sans-serif;
}
#app {
  // font-family: 'AR One Sans', sans-serif;
  font-family: 'Aller Regular', sans-serif;
  background: linear-gradient(180deg, var(--primaryColor) 40%, var(--footerColor) 100%);
  min-height: 100vh;
}

.powered-by {
    position: relative;
    display: block;
    width: 100%;
    height: 30px;
    &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        background: var(--primaryColor);
        background: #23150A;
        filter: brightness(0.85) hue-rotate(-10deg);
        z-index: 0;
    }
    img {
        z-index: 1;
        position: relative;
        display: block;
        margin: auto;
    }
}

</style>
